import React from 'react';
// Se elimina la importación de index.css para evitar errores en entornos aislados
// import "../../index.css";

const PromoBar = () => {
    return (
        <div style={{
            background: "linear-gradient(90deg, #0f3460 0%, #1a56db 50%, #0f3460 100%)",
            padding: "22px 0",
            overflow: "hidden",
            position: "relative",
        }}>
            {/* Detalle decorativo izquierdo */}
            <div style={{
                position: "absolute", left: 0, top: 0, bottom: 0, width: "6px",
                background: "linear-gradient(180deg, #60a5fa, #3b82f6)"
            }} />

            <div className="container">
                <div className="d-flex align-items-center justify-content-center flex-wrap" style={{ gap: "16px" }}>

                    {/* Ícono */}
                    <div
                        className="d-flex align-items-center justify-content-center rounded-circle flex-shrink-0"
                        style={{
                            width: "48px", height: "48px", minWidth: "48px",
                            background: "rgba(255,255,255,0.12)",
                            border: "1px solid rgba(255,255,255,0.2)"
                        }}
                    >
                        <i className="fas fa-lightbulb" style={{ fontSize: "20px", color: "#fbbf24" }}></i>
                    </div>

                    {/* Texto principal */}
                    <p
                        className="m-0 text-white text-center font-weight-bold"
                        style={{ fontSize: "1.1rem", letterSpacing: "0.3px" }}
                    >
                        Aprende algo nuevo hoy. Conviértete en alguien diferente mañana
                        <span
                            className="ml-2 px-2 py-1 rounded"
                            style={{
                                background: "rgba(255,255,255,0.15)",
                                fontSize: "0.8rem",
                                fontWeight: "normal",
                                letterSpacing: "1px",
                                textTransform: "uppercase",
                                verticalAlign: "middle"
                            }}
                        >
                            Empieza ahora
                        </span>
                    </p>

                    {/* CTA CORREGIDO: Faltaba la apertura <a */}
                    <a 
                        href="/courses"
                        className="flex-shrink-0"
                        style={{
                            background: "white",
                            color: "#1a56db",
                            padding: "8px 20px",
                            borderRadius: "50px",
                            fontSize: "0.85rem",
                            fontWeight: "700",
                            textDecoration: "none",
                            whiteSpace: "nowrap",
                            transition: "transform 0.2s",
                            boxShadow: "0 2px 12px rgba(0,0,0,0.2)"
                        }}
                        onMouseEnter={e => e.currentTarget.style.transform = "scale(1.05)"}
                        onMouseLeave={e => e.currentTarget.style.transform = "scale(1)"}
                    >
                        Ver cursos {'\u2192'}
                    </a>

                </div>
            </div>

            {/* Detalle decorativo derecho */}
            <div style={{
                position: "absolute", right: 0, top: 0, bottom: 0, width: "6px",
                background: "linear-gradient(180deg, #3b82f6, #60a5fa)"
            }} />
        </div>
    );
};

export default PromoBar;